import { computed } from 'vue'
import { Statuses } from '@/enum/redesignStatusTypes'
import { allRealtimeExtensions } from '@/composables/useStoreExtensions'

const onlineExtensions = computed(() => {
    const source = allRealtimeExtensions.value
    if (!source) return []
    return source.filter(ex => ex.representativeStatus !== Statuses.LOGOUT)
})
const onlineUserIds = computed(() =>
    onlineExtensions.value.map(ex => ex.representative)
)

export function useExtensions () {
    return {
        extensions: allRealtimeExtensions,
        onlineExtensions,
        onlineUserIds
    }
}